<!--
 * @Author: your name
 * @Date: 2019-09-06 11:38:06
 * @LastEditTime: 2022-03-04 18:07:56
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \Codes\2019\CQ\cq-vs-vote\src\views\Desc.vue
-->
<template>
  <div class="vote-intro-container" v-if="data.description">
    <top-banner :data="data" :countDown="countDown" v-if="dataLen">
      <h2 class="banner-title" slot="banner-title">
        {{ $store.state.voteText }}说明
      </h2>
    </top-banner>
    <div class="vote-intro" v-html="data.description"></div>
  </div>
</template>

<script>
import TopBanner from "../components/TopBanner";

export default {
  name: "",
  data() {
    return {
      data: {},
      dataLen: 0,
      apiParams: {
        id: "",
        isPreview: 0,
      },
      countDown: false,
    };
  },
  components: {
    TopBanner,
  },
  computed: {
    queryConfig() {
      const { queryConfig } = this.$store.state;
      return queryConfig;
    },
  },
  methods: {
    async getData() {
      const orgid = this.$utils.getUrlParams("orgid");
      const { voteInfo, queryConfig } = this.$store.state;
      let response = null;
      this.apiParams.id = this.$utils.getUrlParams("id") || voteInfo.id;
      this.apiParams.isPreview =
        this.$utils.getUrlParams("isPreview") || voteInfo.isPreview;
      if (orgid) {
        // todo 新加密版
        // queryConfig.url =
        //   this.$apis.voteInfo + "?" + this.$urlKeyValue(this.apiParams);
        queryConfig.url = this.$apis.voteInfo;
        queryConfig.params = this.apiParams;
        queryConfig.method = "GET";
        response = await this.$fetchApi(queryConfig);
      } else {
        // todo 旧未加密版
        response = await this.$get(this.$apis.voteInfo, this.apiParams);
      }
      if (response.data.msg === "success") {
        this.data = response.data.data;
        this.dataLen = Object.keys(this.data);
      } else {
        this.$toast.fail(response.data.msg);
      }
    },
  },
  created() {
    this.getData();
  },
  watch: {},
};
</script>

<style scoped lang="less">
.vote-intro-container {
  min-height: 100%;
  background: #fff;
  padding-bottom: 50px;

  .vote-intro {
    min-height: 100%;
    font-size: 0.34rem;
    line-height: 0.5rem;
    padding: 0.32rem;
    text-align: justify;
    margin-top: 0;

    p {
      font-size: 0.34rem;
      line-height: 0.5rem;
      margin-bottom: 0.3rem;
      font-weight: 300;
    }
  }
}
</style>